import { render } from "./TouchBord.vue?vue&type=template&id=1d0a8e59&scoped=true"
import script from "./TouchBord.vue?vue&type=script&lang=js"
export * from "./TouchBord.vue?vue&type=script&lang=js"

import "./TouchBord.vue?vue&type=style&index=0&id=1d0a8e59&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0a8e59"]])

export default __exports__